import React, { useCallback, useEffect, useRef, useState } from "react";

const MIN_WIDTH = 480;
const MIN_HEIGHT = 360;
const VIEWPORT_MARGIN = 16;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function getDefaultRect() {
  const width = Math.min(960, window.innerWidth - VIEWPORT_MARGIN * 2);
  const height = Math.min(640, window.innerHeight - VIEWPORT_MARGIN * 2);
  return {
    x: (window.innerWidth - width) / 2,
    y: (window.innerHeight - height) / 2,
    width,
    height,
  };
}

export function useResizablePanel(active) {
  const [rect, setRect] = useState(getDefaultRect);
  const dragRef = useRef(null);

  useEffect(() => {
    if (active) {
      setRect(getDefaultRect());
    }
  }, [active]);

  const onResizeStart = useCallback((handle, event) => {
    event.preventDefault();
    event.stopPropagation();

    dragRef.current = {
      handle,
      startX: event.clientX,
      startY: event.clientY,
      startRect: { ...rect },
    };

    const onMove = (moveEvent) => {
      const drag = dragRef.current;
      if (!drag) return;

      const dx = moveEvent.clientX - drag.startX;
      const dy = moveEvent.clientY - drag.startY;
      const maxWidth = window.innerWidth - VIEWPORT_MARGIN * 2;
      const maxHeight = window.innerHeight - VIEWPORT_MARGIN * 2;
      const next = { ...drag.startRect };

      if (drag.handle.includes("e")) {
        next.width = clamp(next.width + dx, MIN_WIDTH, maxWidth);
      }
      if (drag.handle.includes("w")) {
        const newWidth = clamp(next.width - dx, MIN_WIDTH, maxWidth);
        next.x += next.width - newWidth;
        next.width = newWidth;
      }
      if (drag.handle.includes("s")) {
        next.height = clamp(next.height + dy, MIN_HEIGHT, maxHeight);
      }
      if (drag.handle.includes("n")) {
        const newHeight = clamp(next.height - dy, MIN_HEIGHT, maxHeight);
        next.y += next.height - newHeight;
        next.height = newHeight;
      }

      next.x = clamp(
        next.x,
        VIEWPORT_MARGIN,
        window.innerWidth - next.width - VIEWPORT_MARGIN
      );
      next.y = clamp(
        next.y,
        VIEWPORT_MARGIN,
        window.innerHeight - next.height - VIEWPORT_MARGIN
      );

      setRect(next);
    };

    const onUp = () => {
      dragRef.current = null;
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  }, [rect]);

  const handles = ["n", "s", "e", "w", "ne", "nw", "se", "sw"];

  const ResizeHandles = () => (
    <>
      {handles.map((handle) => (
        <div
          key={handle}
          className={`track-heading-map-modal__resize track-heading-map-modal__resize--${handle}`}
          onMouseDown={(event) => onResizeStart(handle, event)}
        />
      ))}
    </>
  );

  return { rect, ResizeHandles };
}
